import { SubscriptionDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

export interface GetSubsForUserReturnType {
	totalAvailable: number;
	fetchedCount: number;
	skippedCount: number;
	results: Array<SubscriptionDto>;
}

export const getSubsForUser = ({ orgId }: { orgId: string }) => {
	if (isMockMode()) {
		const testData = {
			results: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					subscription: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						subscriberOrgId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						isDeleted: true,
						isEnabled: true,
						expirationDateUtc: "2023-08-10T02:04:27.595Z",
						lastUpdatedDateUtc: "2023-08-10T02:04:27.595Z",
					},
				},
			],
		};

		return simulateDelay(
			50,
			() => testData
		) as Promise<GetSubsForUserReturnType>;
	}

	return getBlast(
		`subscriptions/getforuser?orgId=${orgId}`
	) as Promise<GetSubsForUserReturnType>;
};
